import React from 'react'
import ApiResponseComponent from './FormattedResponse'

function Chatbot(){

    

    const [prompt, setPrompt] = React.useState('')
    const [messages, setMessages] = React.useState([])
    const [loading, setLoading] = React.useState(false)
    const [error, setError] = React.useState(null)
    const [sessionTokens, setSessionTokens] = React.useState(0)
    const [lastRequestTokens, setLastRequestTokens] = React.useState(null)
    const chatEndRef = React.useRef(null);
    
    // Token limits (aligned with backend)
    const MAX_TOKENS_PER_MESSAGE = 50;  // Backend trims at 150
    const MAX_TOKENS_PER_SESSION = 1000;  // Increased to accommodate backend limits

    const scrollToBottom = () => {
      chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
    };
  
    React.useEffect(() => {
      scrollToBottom();
    }, [messages]);

    // Token estimation function (aligned with backend: 1 token ≈ 4 characters)
    const estimateTokens = (text) => {
        return Math.floor(text.length / 4);  // Changed to floor to match backend
    };

    // Validate token limits
    const validateTokenLimits = (messageText) => {
        const messageTokens = estimateTokens(messageText);
        
        // Check per-message limit (backend will trim but warn user)
        if (messageTokens > MAX_TOKENS_PER_MESSAGE) {
            throw new Error(`Message too long! Please keep it under ${MAX_TOKENS_PER_MESSAGE} tokens (≈${MAX_TOKENS_PER_MESSAGE * 4} characters). Backend will trim your conversation history.`);
        }
        
        // Check session limit
        if (sessionTokens + messageTokens > MAX_TOKENS_PER_SESSION) {
            throw new Error(`Session token limit reached! You've used ${sessionTokens}/${MAX_TOKENS_PER_SESSION} tokens. Please start a new session.`);
        }
        
        return messageTokens;
    };

    // Backend now handles conversation trimming automatically


    //const handleOpenAI = async()=>{
        
        //     const response = await fetch('https://api.openai.com/v1/chat/completions',{
        //         method:'POST',
        //         headers:{
        //             "Content-Type": "application/json",
        //             Authorization: `Bearer ${APIKey}`
        //         },
        //         body:JSON.stringify({
        //             model:'gpt-3.5-turbo',
        //             messages:[{role:"user", content:prompt}],
        //             max_tokens: 1024, 
        //             temperature: 0
        //         })
        //     })
    
           
        //     if(response.ok){
        //         const data = await response.json()
        //         const modelResponse = data.choices[0].message.content
        //         console.log(modelResponse)
        //         setLoading(false)
        //     }
            
        // }
    
    
    const handleInput = (e)=>{
        const {value} = e.target
        setPrompt(value)
    }

    // Handle Enter key press to send message
    const handleKeyDown = (e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault(); // Prevent new line
            handleQuery(e);
        }
    }



    const HandleClear = (e)=>{
        setPrompt('')
        setMessages([])
        setError(null)
        setSessionTokens(0)
        setLastRequestTokens(null)
    }



    

    const handleQuery = async (e)=>{

        e.preventDefault()
        const whitespacePattern = /^[\s]*$/;
        try{
            if(whitespacePattern.test(prompt)){
                setPrompt('')
                throw new Error('Oops! cannot think of a query with empty string. Please ask something valid 😄')
            }
            
            // Validate token limits
            const messageTokens = validateTokenLimits(prompt);
            
            // Ensure proper role alternation - remove any trailing user messages
            let filteredMessages = [...messages];
            if (filteredMessages.length > 0 && filteredMessages[filteredMessages.length - 1].role === 'user') {
                // Remove the last user message if there's no assistant response
                filteredMessages.pop();
            }
            
            // Backend handles token optimization automatically
            const APIBody = [...filteredMessages, {role:'user', content: prompt}];
            //setMessages((preVal)=> [...preVal, prompt])
            setMessages(APIBody)
            console.log(messages)
            setError(null)
            setLoading(true)
            
            const response = await fetch(process.env.REACT_APP_API_URL,{
                method: 'POST',
                headers: {
                'Content-Type':'application/json',
                'x-api-key': process.env.REACT_APP_API_KEY,
                },
                body: JSON.stringify({
                 "prompt": APIBody
                })
            })
    
           
            if(response.ok){
                const modelResponse = await response.json()
                console.log(modelResponse)
                const assistantMessage = modelResponse.content[0].text;
                
                // Extract token usage if available
                const usageTracking = modelResponse.usage_tracking;
                if (usageTracking) {
                    // Only use actual tokens from API (backend already handles trimming)
                    const totalTokens = usageTracking.input_tokens + usageTracking.output_tokens;
                    setSessionTokens(prev => prev + totalTokens);
                    setLastRequestTokens(usageTracking);
                    
                    console.log('Token usage:', usageTracking);
                } else {
                    // Fallback to estimation (only for user input + response)
                    const responseTokens = estimateTokens(assistantMessage);
                    const userInputTokens = estimateTokens(prompt);
                    setSessionTokens(prev => prev + userInputTokens + responseTokens);
                }
                
                setMessages((preVal)=> [...preVal, {role:'assistant', content:assistantMessage}])
                setLoading(false)
                setPrompt('')
            }else if(!response.ok){
                throw new Error(await response.json())
            }
        }catch(err){
            //setMessages((preVal)=> [...preVal, {role:'assistant', content:err.message}])
            setError(err.message)
            setLoading(false)
        }
    
    }
         

    

    return(<div className='chatbot-container'>


    {messages.map((message, index) => (
          <div className={message.role === 'assistant' ? 'assistant-message' : 'user-message'} key={index}>
          <ApiResponseComponent message={message} />
          <div ref={chatEndRef} />
          </div>
        ))}

        {loading && (
                <div className="loading-container">
                    <div className="spinner"></div>
                </div>
            )}

        {error && <p className="error-message">{error}</p>}
        
        <div className="usage-tracking">
            <div className="token-counter">
                <small>Session tokens: {sessionTokens}/{MAX_TOKENS_PER_SESSION}</small>
            </div>
            {lastRequestTokens && (
                <div className="last-request">
                    <small>Last request: Input {lastRequestTokens.input_tokens}, Output {lastRequestTokens.output_tokens} tokens</small>
                </div>
            )}
        </div>
        
    <form onSubmit={handleQuery}>
        <textarea 
            type='text' 
            name='prompt' 
            placeholder='enter query (Press Enter to send, Shift+Enter for new line)' 
            onChange={handleInput} 
            onKeyDown={handleKeyDown}
            rows='6' 
            cols='50' 
            required 
            value={prompt}
        ></textarea>
        <button type="submit" disabled={loading}>Ask me</button> 
        <button type="button" disabled={loading} onClick={HandleClear}>Clear</button> 
    </form>
    
    
   
       
 
    </div>)

}

export default Chatbot
